import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { OrderSummaryMetricRow } from '@/experiences/sales-portal/domain/ordering/containers/checkout-panel/blocs/hooks/use-order-summary-metric-rows';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface OrderSummaryMetricsProps {
  metricRows: OrderSummaryMetricRow[];
  subtotalDisplayString: string;
  unitCount: number;
}

export const OrderSummaryMetrics: React.FC<OrderSummaryMetricsProps> = ({
  metricRows,
  subtotalDisplayString,
  unitCount,
}) => {
  const [styles, theme] = useStyles();

  return (
    <View style={styles.metricsContainer}>
      {metricRows.map((row) => (
        <View key={row.key} style={styles.metricRow}>
          <Typography
            color={theme.sk.color.text.primary}
            variant="paragraph-base"
          >
            {row.label}
          </Typography>
          <Typography
            color={theme.sk.color.text.primary}
            variant="paragraph-base"
          >
            {row.value}
          </Typography>
        </View>
      ))}
      <View style={styles.metricRow}>
        <Typography variant="paragraph-base">
          {i18n.t('sales_portal.checkout_panel.summary.units')}{' '}
          <Typography variant="paragraph-base-600">{unitCount}</Typography>
        </Typography>
        <Typography
          color={theme.sk.color.text.primary}
          variant="paragraph-base-600"
        >
          {subtotalDisplayString}
        </Typography>
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  metricRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  metricsContainer: {
    flexDirection: 'column',
    gap: theme.sk.spacing.spaceSmall,
    paddingTop: theme.sk.spacing.spaceSmall,
  },
}));
